import { Box, Text } from '@chakra-ui/react'
import { colors } from '../../../../utilities/colors'

export default function LocationSummary({ label, value, accent }) {
  if (!value?.postal_code) return null
  return (
    <Box
      w="full"
      pl={3}
      py={2}
      borderLeft="4px solid"
      borderLeftColor={accent}
      bg={`${accent}10`}
      borderRadius="md"
    >
      <Text fontSize="xs" fontWeight="semibold" color={accent}>
        {label}
      </Text>
      <Text fontSize="sm" color={colors.grey100} truncate>
        {value.name ? `${value.name} — ` : ''}{value.city}, {value.state} {value.postal_code}
      </Text>
    </Box>
  )
}
